import StepUpPrompt from '@/components/Mfa/StepUpPrompt';
import ThemeProvider from '@/components/ThemeProvider';
import { useApollo } from '@/hooks/apollo';
import { ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import DayjsUtils from '@date-io/dayjs';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { AppProps } from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import { SnackbarProvider } from 'notistack';
import React from 'react';

const googleApiKey = process.env.NEXT_PUBLIC_GOOGLE_API_KEY ?? '';

if (!googleApiKey) {
  // eslint-disable-next-line no-console
  console.log('WARNING: Google API Key is not defined');
}

export default function App(
  props: AppProps<{ initialApolloState: NormalizedCacheObject }>,
): JSX.Element {
  const { Component, pageProps } = props;
  const apolloClient = useApollo(pageProps.initialApolloState);

  React.useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement?.removeChild(jssStyles);
    }
  }, []);

  return (
    <ApolloProvider client={apolloClient}>
      <Head>
        <title>Nomad MD</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
      </Head>
      <Script
        src={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places,drawing`}
        strategy="beforeInteractive"
      />
      <Script
        src="https://js.finix.com/v/1/finix.js"
        strategy="beforeInteractive"
      />
      <ThemeProvider>
        <MuiPickersUtilsProvider utils={DayjsUtils}>
          <SnackbarProvider
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            dense
          >
            <CssBaseline />
            <Component {...pageProps} />
            <StepUpPrompt />
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
}
